// App.js
import "./App.css";
import { useState, useEffect } from "react";
import searchIcon from "./assets/search-outline.svg";
import MovieCard from "./components/MovieCard";
import MovieDetail from "./components/MovieDetail";

const API_URL = "http://omdbapi.com?apikey=c9952141";

const App = () => {
    const [movies, setMovies] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedMovie, setSelectedMovie] = useState(null);

    const searchMovies = async (title) => {
        try {
            const response = await fetch(`${API_URL}&s=${title}`);
            const data = await response.json();
            console.log("Search API Response:", data); // Log della risposta dell'API
            if (data.Search) {
                setMovies(data.Search);
            } else {
                setMovies([]); // Imposta a vuoto se non ci sono risultati
            }
        } catch (error) {
            console.error("Errore nella chiamata API:", error);
        }
    };

    const showMovieDetail = async (imdbID) => {
        try {
            const response = await fetch(`${API_URL}&i=${imdbID}&plot=full`);
            const data = await response.json();
            console.log("Movie Details API Response:", data); // Log della risposta dell'API
            setSelectedMovie(data);
        } catch (error) {
            console.error("Errore nella chiamata API:", error);
        }
    };

    useEffect(() => {
        searchMovies(""); // Chiamata iniziale per cercare film
    }, []);

    useEffect(() => {
        console.log("Selected Movie Updated:", selectedMovie); // Log per monitorare i cambiamenti
    }, [selectedMovie]);

    return (
        <div className="app">
            <h1>Mele Movies</h1>

            <div className="search">
                <input
                    placeholder="Cerca per film"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <img
                    src={searchIcon}
                    alt="Search movies"
                    onClick={() => searchMovies(searchTerm)}
                />
            </div>

            {movies.length > 0 ? (
                <div className="container">
                    {movies.map((movie) => (
                        <MovieCard
                            key={movie.imdbID}
                            movie={movie}
                            onClick={() => showMovieDetail(movie.imdbID)}
                        />
                    ))}
                </div>
            ) : (
                <div className="empty">
                    <h2>Non ho trovato film :(</h2>
                </div>
            )}

            {selectedMovie && <MovieDetail selectedMovie={selectedMovie} />}
        </div>
    );
};

export default App;